"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetFavouriteApplicationStatusCommand = void 0;
class SetFavouriteApplicationStatusCommand {
    constructor(userId, studyId, applicationStatus, expectedState, isLocal) {
        this.userId = userId;
        this.studyId = studyId;
        this.applicationStatus = applicationStatus;
        this.expectedState = expectedState;
        this.isLocal = isLocal;
    }
}
exports.SetFavouriteApplicationStatusCommand = SetFavouriteApplicationStatusCommand;
